import productApi from "@/api/product";
import brand from "@/api/brand";
import category from "@/api/category";
import nation from "@/api/nation";
import { formatCategories } from "@/utils/common";
const product = {
  state: {
    brandList: [],
    categories: [],
    nationList: [],
    categoryList: [],
    currencyMap: {
      GBP: "英镑",
      HKD: "港币",
      USD: "美元",
      CHF: "瑞士法郎",
      SGD: "新加坡元",
      SEK: "瑞典克朗",
      DKK: "丹麦克朗",
      NOK: "挪威克朗",
      JPY: "日元",
      CAD: "加拿大元",
      AUD: "澳大利亚元",
      EUR: "欧元",
      NZD: "新西兰元",
      RUB: "俄罗斯卢布",
      MOP: "澳门元",
      TWD: "新台币",
      KRW: "韩元",
      RMB: "人民币",
    },
  },
  getters: {
    brandList(state) {
      return state.brandList.map((brand) => {
        return {
          label: brand.brandName,
          value: brand.brandId,
        };
      });
    },
    categories(state) {
      const categories = formatCategories(state.categories);
      const { children } = categories;
      return children ? children : [];
    },
    nationList(state) {
      return state.nationList.map((nation) => {
        return {
          value: nation.id,
          label: nation.nationNameCn,
        };
      });
    },
    categoryList(state) {
      return state.categoryList;
    },
  },
  mutations: {
    setNationList(state, data) {
      state.nationList = data;
    },
    setBrandList(state, data) {
      state.brandList = data;
    },
    setAllCategories(state, data) {
      state.categories = data;
    },
    setCategoryList(state, data) {
      state.categoryList = data;
    },
  },
  actions: {
    productList({ commit }, data) {
      return productApi.list(data);
    },
    addProduct({ commit }, data) {
      return productApi.addProduct(data);
    },
    exportProductList({ commit }, data) {
      return productApi.exportSkuInfo(data);
    },
    deleteProduct({ commit }, data) {
      return productApi.deleteProduct(data);
    },
    copyProduct({ commit }, data) {
      return productApi.copyProduct(data);
    },
    lockProduct({ commit }, data) {
      return productApi.lockProduct(data);
    },
    unLockProduct({ commit }, data) {
      return productApi.unLockProduct(data);
    },
    supplyProduct({ commit }, data) {
      return productApi.supplyProduct(data);
    },
    stopSupplyProduct({ commit }, data) {
      return productApi.stopSupplyProduct(data);
    },
    updateProduct({ commit }, data) {
      return productApi.updateProduct(data);
    },
    exportSkuInfo({ commit }, data) {
      return productApi.exportSkuInfo(data);
    },
    brandList({ commit }, data) {
      return brand.list(data).then((res) => {
        commit("setBrandList", res.result);
        return res;
      });
    },
    createOrUpdate({ commit }, data) {
      return brand.createOrUpdate(data);
    },
    deleteBrands({ commit }, data) {
      return brand.deleteBrands(data);
    },
    downloadBrandList({ commit }, data) {
      return brand.downloadBrandList(data);
    },
    nationList({ commit }, data) {
      return nation.getNationList(data).then((res) => {
        commit("setNationList", res.value);
      });
    },
    getCategories({ commit }, data) {
      return category.list(data).then((res) => {
        commit("setCategoryList", res.result);
      });
    },
    getAllCategories({ commit }, data) {
      return category.queryAllCategories(data).then((res) => {
        commit("setAllCategories", res);
      });
    },
    previewBatchImportProduct({ commit }, data) {
      return productApi.previewBatchImportProduct(data);
    },
    batchImportProduct({ commit }, data) {
      return productApi.batchImportProduct(data);
    },
    productDetail({ commit }, data) {
      return productApi.getSkuDetail(data);
    },
    skuExtend({ commit }, data) {
      return productApi.updateSkuExtend(data);
    },
    productDeclareList({ commit }, data) {
      return productApi.queryProductDeclare(data);
    },
    downloadProductDeclare({ commit }, data) {
      return productApi.downloadProductDeclare(data);
    },
  },
};

export default product;
